import SupplyLocationIDSelector from '@/views/components/Selectors/SupplyLocationIDSelector';
import SupplyRegionsSelector from '@/views/components/Selectors/SupplyRegionsSelector';
import SupplyRscmSelector from '@/views/components/Selectors/SupplyRscmSelector';
import { Form } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { saveSupplyZone } from '../../../redux/Savers/SaversEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import PrimaryLabel from '../../components/Labels/PrimaryLabel';
import AlertModal from '../../components/Modals/AlertModal';
import Drawer from '../../components/Modals/Drawer';

const SupplyZoneSearch = ({ onSearchClick }) => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [hidden, setHidden] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [selectedIds, setSelectedIds] = useState({
    selectedLocationId: '',
    selectedRegionId: '',
    selectedRscmId: '',
  });

  const { selectedLocationId, selectedRegionId, selectedRscmId } = selectedIds;

  const handleFieldSelect = (field, value) => {
    setSelectedIds((prev) => ({ ...prev, [field]: value }));
  };

  const OpenSZPopup = () => {
    setHidden(true);
  };

  const handleSave = () => {
    dispatch(setAppLoader(true));

    const data = [
      {
        branchKey: selectedLocationId,
        rscmUserId: selectedRscmId,
        regionKey: selectedRegionId,
      },
    ];

    saveSupplyZone(data)
      .then(() => {
        dispatch(setAppLoader(false));
        setAlertMessage('Saved successfully');
        setAlertOpen(true);
        form.resetFields();
        setHidden(false);
        onSearchClick();
      })
      .catch((error) => {
        console.error('Save failed:', error);
        dispatch(setAppLoader(false));
      });
  };

  const closeModal = () => {
    form.resetFields();
    setHidden(false);
  };

  const handleAlertOk = () => {
    setAlertOpen(false);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  return (
    <>
      <Drawer
        width="40%"
        open={hidden}
        headerContents={<PrimaryLabel className="text-white">CT Location Management page</PrimaryLabel>}
        onClose={closeModal}
      >
        <AlertModal
          title="Alert"
          open={alertOpen}
          description={alertMessage}
          onOk={handleAlertOk}
          onClose={handleAlertClose}
        />

        <div className="popup-body p-2">
          <Form form={form}>
            <div class="row">
              <div className="col">
                <label htmlFor="">New Location ID</label>

                <div>
                  <SupplyLocationIDSelector
                    editMode
                    name="SZID2"
                    value={selectedLocationId}
                    margin="m-0"
                    placeholder="SZ #"
                    onChange={(e) => handleFieldSelect('selectedLocationId', e.value)}
                  />
                </div>
              </div>

              <div className="col">
                <label htmlFor="">RSCM </label>

                <div>
                  <SupplyRscmSelector
                    editMode
                    name="rscm"
                    margin="m-0"
                    placeholder="RSCM"
                    onChange={(e) => handleFieldSelect('selectedRscmId', e.value)}
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div className="col">
                <label htmlFor="">Region</label>

                <div>
                  <SupplyRegionsSelector
                    editMode
                    name="region"
                    margin="m-0"
                    placeholder="Region"
                    onChange={(e) => handleFieldSelect('selectedRegionId', e.value)}
                  />
                </div>
              </div>

              <div className="col text-center mt-3">
                <button type="button" className="btn btn-dipblue" onClick={handleSave}>
                  {' '}
                  Submit{' '}
                </button>
              </div>
            </div>
          </Form>
        </div>
      </Drawer>

      <button type="button" className="btn btn-dipblue" onClick={OpenSZPopup}>
        {' '}
        Update SZ{' '}
      </button>
    </>
  );
};

export default SupplyZoneSearch;
